import * as fromSmartcountsList from '../../../../../../reducers/TargetedComms/Smartcounts/list';

export const getStageCount = (state) => fromSmartcountsList.getStageCount(state);
export const getCampaignList = (state) => fromSmartcountsList.getCampaignList(state);
export const getExecutionList = (state) => fromSmartcountsList.getExecutionList(state);
export const getExecutionCycle = (state) => fromSmartcountsList.getExecutionCycle(state);
